// Updated by Elevate: 2026-01-02T23:26:28.996Z
// Safe Performance Optimizations - Prevent Layout Shifts
(function() {
  'use strict';

  // Add dimensions to images to prevent layout shifts
  function preventImageShifts() {
    const images = document.querySelectorAll('img:not([data-dims-set])');

    images.forEach(img => {
      // Mark as processed
      img.dataset.dimsSet = 'true';

      // If image already has natural dimensions, set them
      if (img.naturalWidth && img.naturalHeight) {
        if (!img.width) img.width = img.naturalWidth;
        if (!img.height) img.height = img.naturalHeight;

        // Add aspect ratio for modern browsers
        if (!img.style.aspectRatio) {
          img.style.aspectRatio = `${img.naturalWidth}/${img.naturalHeight}`;
        }
      } else {
        // Wait for image to load then set dimensions
        img.addEventListener('load', function() {
          if (!this.width && this.naturalWidth) {
            this.width = this.naturalWidth;
            this.height = this.naturalHeight;
          }
          if (!this.style.aspectRatio && this.naturalWidth) {
            this.style.aspectRatio = `${this.naturalWidth}/${this.naturalHeight}`;
          }
        });
      }

      // Set loading attribute for better performance
      const rect = img.getBoundingClientRect();
      const inViewport = rect.top < window.innerHeight && rect.bottom > 0;

      if (!img.loading) {
        if (inViewport) {
          img.loading = 'eager';
          // Priority for above-the-fold images
          if (rect.top < window.innerHeight / 2) {
            img.fetchpriority = 'high';
          }
        } else {
          img.loading = 'lazy';
        }
      }
    });
  }

  // Optimize Shopify responsive images
  function optimizeResponsiveImages() {
    const images = document.querySelectorAll('img[src*="cdn.shopify.com"]:not([srcset])');

    images.forEach(img => {
      if (!img.src || img.srcset) return;

      // Generate responsive srcset for Shopify images
      const src = img.src;
      const widths = [165, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

      // Only create srcset for reasonably sized images
      if (img.width > 100 || img.naturalWidth > 100) {
        const srcset = widths
          .filter(w => w <= (img.naturalWidth || img.width || 2048) * 2)
          .map(w => {
            const url = src.replace(/(_\d+x\d*)?(\.\w+)(\?.*)?$/, `_${w}x$2$3`);
            return `${url} ${w}w`;
          })
          .join(', ');

        if (srcset) {
          img.srcset = srcset;
          img.sizes = img.sizes || '(min-width: 750px) 50vw, 100vw';
        }
      }
    });
  }

  // Stabilize header dimensions
  function stabilizeHeader() {
    const header = document.querySelector('.header');
    if (header && !header.style.minHeight) {
      const height = header.offsetHeight;
      if (height > 0) {
        header.style.minHeight = height + 'px';
      }
    }

    // Stabilize logo
    const logo = document.querySelector('.header__heading-logo');
    if (logo && logo.tagName === 'IMG') {
      if (!logo.width && logo.naturalWidth) {
        logo.width = logo.naturalWidth;
        logo.height = logo.naturalHeight;
      }
    }
  }

  // Initialize performance optimizations
  function init() {
    // Run immediately
    preventImageShifts();
    stabilizeHeader();

    // Run after DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        preventImageShifts();
        optimizeResponsiveImages();
        stabilizeHeader();
      });
    } else {
      optimizeResponsiveImages();
    }
  }

  // Start optimizations
  init();

  // Re-run when new content is added (for dynamic content)
  const observer = new MutationObserver(function(mutations) {
    // Debounce to avoid excessive processing
    if (observer.timeout) clearTimeout(observer.timeout);
    observer.timeout = setTimeout(function() {
      preventImageShifts();
      optimizeResponsiveImages();
    }, 100);
  });

  // Observe for dynamic content
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Expose for debugging
  window.SafePerformance = {
    preventImageShifts: preventImageShifts,
    optimizeResponsiveImages: optimizeResponsiveImages,
    stabilizeHeader: stabilizeHeader
  };
})();

/*
  Altitude subscription integrity fix.

  The custom product pages render a "Subscribe & Save" option whose discount is
  calculated in Liquid, with no selling_plan field on the form. That makes every
  add-to-cart a one-time purchase at full price. This runs on any product page
  that uses those buy boxes and either:
    - wires the option to the product's REAL Shopify selling plan, or
    - removes the option entirely when the product has no subscription set up.

  Pages that already handle this themselves (they render their own
  #altitude-selling-plan-input) are left completely untouched.
*/
(function() {
  'use strict';

  function run() {
    var subRadio = document.querySelector('.altitude-mode-radio[value="subscribe"]');
    if (!subRadio) return;
    if (document.getElementById('altitude-selling-plan-input')) return; // page handles itself
    if (document.documentElement.dataset.altSubFix === 'done') return;
    document.documentElement.dataset.altSubFix = 'done';

    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;

    fetch('/products/' + match[1] + '.js', { headers: { Accept: 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var variants = product.variants || [];
        var hasPlans = variants.some(function(v) {
          return v.selling_plan_allocations && v.selling_plan_allocations.length;
        });
        hasPlans ? enableRealSubscription(subRadio, variants) : removeSubscription(subRadio);
      })
      .catch(function() { removeSubscription(subRadio); });
  }

  function money(cents) { return '\u00a3' + (cents / 100).toFixed(2); }

  // No subscription exists in Shopify for this product, so the option is
  // misleading. Strip it and fall back to a one-time purchase.
  function removeSubscription(subRadio) {
    var block = subRadio.closest('label');
    if (block) block.remove();

    var group = document.querySelector('.altitude-mode-group[data-mode="subscribe"]');
    if (group) group.remove();

    var oneTime = document.querySelector('.altitude-mode-radio[value="onetime"]');
    if (oneTime) {
      oneTime.checked = true;
      // Let the page's own setMode() re-enable the one-time variant pills
      // and recalculate the displayed totals.
      oneTime.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // A real selling plan exists: add the field Shopify needs and keep it in
  // sync with the selected variant and purchase mode.
  function enableRealSubscription(subRadio, variants) {
    var form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    var byId = {};
    variants.forEach(function(v) { byId[String(v.id)] = v; });

    var planInput = document.createElement('input');
    planInput.type = 'hidden';
    planInput.name = 'selling_plan';
    planInput.id = 'altitude-selling-plan-input';
    form.appendChild(planInput);

    // Correct the displayed subscription prices, which were a hardcoded 15%.
    document.querySelectorAll('.altitude-variant-radio[data-mode="subscribe"]').forEach(function(radio) {
      var variant = byId[String(radio.value)];
      var alloc = variant && variant.selling_plan_allocations && variant.selling_plan_allocations[0];
      if (!alloc) return;
      radio.setAttribute('data-plan', alloc.selling_plan_id);
      radio.setAttribute('data-sub-price', alloc.price);
      var pill = radio.nextElementSibling;
      var priceEl = pill && pill.querySelector('span');
      if (priceEl) priceEl.textContent = money(alloc.price);
    });

    function sync() {
      var subscribing = subRadio.checked;
      var checked = document.querySelector('.altitude-variant-radio[data-mode="' + (subscribing ? 'subscribe' : 'onetime') + '"]:checked');
      var variant = checked ? byId[String(checked.value)] : null;
      var alloc = variant && variant.selling_plan_allocations && variant.selling_plan_allocations[0];

      if (subscribing && alloc) {
        planInput.value = alloc.selling_plan_id;
        planInput.disabled = false;
      } else {
        planInput.value = '';
        planInput.disabled = true;
      }
    }

    document.querySelectorAll('.altitude-mode-radio, .altitude-variant-radio').forEach(function(el) {
      el.addEventListener('change', sync);
    });
    form.addEventListener('submit', sync, true);
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
